/* gk-patches */
if (!customElements.get('gk-patches')) {
  class GkPatches extends HTMLElement {
    connectedCallback() {
      this.toggles = Array.from(this.querySelectorAll('[data-gkp-toggle]'));
      this.toggles.forEach((input) => {
        input.addEventListener('change', () => {
          // Comportamento radio: se ativou esse, desativa os outros
          if (input.checked) {
            this.toggles.forEach((other) => {
              if (other !== input && other.checked) {
                other.checked = false;
              }
            });
          }
          this.toggles.forEach((t) => this.updateUI(t));
        });
        this.updateUI(input);
      });

      this.handleSubmit = this.handleSubmit.bind(this);
      document.addEventListener('submit', this.handleSubmit, true);
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.handleSubmit, true);
    }

    updateUI(input) {
      const item = input.closest('.gkpa__item');
      if (item) item.classList.toggle('is-active', input.checked);
    }

    isCartAddForm(form) {
      if (!(form instanceof HTMLFormElement)) return false;
      const action = form.getAttribute('action') || '';
      return action.indexOf('/cart/add') !== -1;
    }

    getActivePatches() {
      const result = [];
      this.toggles.forEach((input) => {
        if (!input.checked) return;
        const item = input.closest('.gkpa__item');
        if (!item) return;
        const variantId = item.dataset.gkpVariantId;
        const name = item.dataset.gkpName || '';
        if (variantId) result.push({ id: parseInt(variantId, 10), name: name });
      });
      return result;
    }

    handleSubmit(e) {
      const form = e.target;
      if (!this.isCartAddForm(form)) return;

      const productInfo = this.closest('product-info');
      if (productInfo && !productInfo.contains(form)) return;

      // Re-submissão feita por nós mesmos (passo 4): deixa o Dawn seguir com a property "Badges"
      if (this.resubmitting) {
        this.resubmitting = false;
        return;
      }

      const patches = this.getActivePatches();
      if (patches.length === 0) {
        // Nenhum badge marcado: remove a property "Badges" que tenha sobrado de uma adição anterior
        const stale = form.querySelector('input[name="properties[Badges]"]');
        if (stale) stale.remove();
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      this.submitWithPatches(form, patches);
    }

    async submitWithPatches(form, patches) {
      const submitBtn = form.querySelector('[type="submit"]');
      const productForm = form.closest('product-form');

      // Dawn's cart instance (cart-notification or cart-drawer)
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
        const spinner = submitBtn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }
      if (productForm) {
        productForm.handleErrorMessage && productForm.handleErrorMessage();
      }

      try {
        const cartAddUrl =
          (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';

        // 1. Adiciona cada badge via fetch (silencioso, sem renderizar drawer)
        for (const p of patches) {
          const f = new FormData();
          f.append('id', p.id);
          f.append('quantity', 1);
          const r = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: f,
          });
          const d = await r.json();
          if (!r.ok || d.status) throw d;
        }

        // 2. Insere property "Badges" no form principal (input hidden)
        const names = patches.map((p) => p.name).filter(Boolean).join(', ');
        if (names) {
          let badgesInput = form.querySelector('input[name="properties[Badges]"]');
          if (!badgesInput) {
            badgesInput = document.createElement('input');
            badgesInput.type = 'hidden';
            badgesInput.name = 'properties[Badges]';
            form.appendChild(badgesInput);
          }
          badgesInput.value = names;
        }

        // 3. Desmarca os toggles pra próxima submissão não disparar nosso intercept
        this.toggles.forEach((t) => {
          t.checked = false;
          this.updateUI(t);
        });

        // 4. Re-submete o form — Dawn vai interceptar e fazer o flow nativo (que funciona)
        if (submitBtn) {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
          const spinner = submitBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }

        if (form.requestSubmit) {
          this.resubmitting = true;
          form.requestSubmit(submitBtn || undefined);
          this.resubmitting = false; // o evento submit é síncrono; garante que a trava não fique presa
        } else {
          form.submit();
        }
        return; // sai antes do finally pra não desabilitar de novo
      } catch (err) {
        console.error('[gk-patches] add error', err);
        const msg =
          (err && (err.description || err.message)) || 'Não foi possível adicionar ao carrinho.';
        if (productForm && typeof productForm.handleErrorMessage === 'function') {
          productForm.handleErrorMessage(msg);
        } else {
          alert(msg);
        }
      } finally {
        if (submitBtn) {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
          const spinner = submitBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      }
    }
  }
  customElements.define('gk-patches', GkPatches);
}
